const bookSlides = [
    {
        id: 1,
        title: "Agenda Astral Zéfiro 2026",
        author: "Rosa María Cifuentes Castañeda",
        image: "/assets/images/Book_Agenda_Astral_Zéfiro_2026_más_Calendario.jpg",
        sinopsis: "Lleva contigo la energía del nuevo año con nuestra Agenda Astral Zéfiro + Calendario Lunar 2026. Astrología, fases de la luna, numerología, cábalas y rituales para que cada mes te conectes con tu mejor energía.",
        linkCrisol: "https://www.crisol.com.pe/preventa-pack-astral-zefiro-2026-rosa-maria-cifuentes?srsltid=AfmBOooaavKxU_5IGdMFSvIt6JmyACIP8AMzhiRr5TxpAISSmCcQR9mu",
        linkSBS: "https://www.sbs.com.pe/pack-astral-zefiro-2026.html",
        linkIbero: "https://www.iberolibrerias.com/pack-astral-zefiro-2026-7756444001037-212292/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-agenda-astral-zefiro-2026-mas-calendario/7756444001037/p/64588882",
        year: 2025,
        themes: ["Agenda", "Autoayuda", "Astrología"],
        pages: 280,
        linkVirrey: "https://www.elvirrey.com/libro/agenda-astral-zefiro-2026_70153689",
        linkSur: "https://www.libreriasur.com.pe/busqueda/listaLibros.php?tipoBus=full&palabrasBusqueda=Agenda+Astral+Z%C3%A9firo+2026",
        linkEP: "",
        isNew: true
    },
    { id: 2,
        title: "La Casa te elige a ti",
        image: "/assets/images/Book_La_casa_te_elige_a_ti.png",
        sinopsis: "¿Alguna vez sentiste que, desde que llegaste a cierta casa, todo empezó a ir mal?\n" +
            "\n" +
            "Caos, enfermedad, estancamiento… No es casualidad. Tu hogar tiene un mensaje para ti.\n" +
            "\n" +
            "Luego del éxito de La magia de tu casa, Rosa María Cifuentes regresa con una reveladora propuesta: La casa te elige a ti. Un libro basado en años de investigación, que expone con claridad, —casos reales y con asombroso material gráfico— cómo cada espacio que habitamos refleja nuestra historia emocional, nuestro karma y hasta nuestro dharma.\n" +
            "\n" +
            "¿Cómo influye la forma de tu casa en tu estado emocional?\n" +
            "\n" +
            "¿Qué revela tu fecha de nacimiento sobre el tipo de energía que atraes?\n" +
            "\n" +
            "¿Por qué ciertas casas parecen «enfermarnos»?\n" +
            "\n" +
            "¿Cómo tu salud mental y tus relaciones están conectadas con tu entorno?\n" +
            "\n" +
            "A través de herramientas como la astrología, la numerología y el coaching emocional, este libro te guiará para entender qué dice tu casa sobre ti, por qué estás experimentando lo que vives y cómo transformar tu realidad para crecer en paz, conciencia y prosperidad.",
        linkCrisol: "https://www.crisol.com.pe/libro-la-casa-te-elige-a-ti-9786125111487",
        linkSBS: "https://www.sbs.com.pe/la-casa-te-elige-a-ti.html",
        linkIbero: "https://www.iberolibrerias.com/9786125111487?map=isbn",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-la-casa-te-elige-a-ti/9786125111487/p/64539631",
        year: 2025,
        themes: ["Autoayuda", "Astrología"],
        pages: 244,
        linkVirrey: "https://www.elvirrey.com/libro/la-casa-te-elige-a-ti_70152568",
        linkSur: "https://www.libreriasur.com.pe/libro/la-casa-te-elige-a-ti_172647",
        linkEP: "https://www.entrepaginas.pe/libro/la-casa-te-elige-a-ti-100582",
        isNew: true
    },
    {
        id: 3,
        title: "Como aman ellas",
        image: "/assets/images/Book_como_aman_ellas.jpg",
        sinopsis: "Cómo aman ellas es el reflejo donde cada mujer puede mirarse, porque es el resultado de casos reales investigados por la autora. Mujeres que aman con dependencia hasta humillarse, mujeres que aman el dinero más que nada, mujeres que conquistan sin entregarse para vengarse del progenitor, mujeres que solo saben ser la “amante”, mujeres infieles por narcisismo...",
        linkCrisol: "https://www.crisol.com.pe/catalogsearch/result/?q=C%C3%B3mo+aman+ellas",
        linkSBS: "https://www.sbs.com.pe/como-aman-ellas-9786124650291.html",
        linkIbero: "https://www.iberolibrerias.com/como-aman-ellas-9786124181573-330901/p?idsku=1980&gad_source=1&gad_campaignid=18039863708&gbraid=0AAAAAoyWx9wPUz-4AJ9HeZ-4rV91fOB0q&gclid=CjwKCAjwiY_GBhBEEiwAFaghviyfkGTclDb9e-RDwMjmEor_7t8Y3GaFRB7NxNXMTUTr_MA_39J7bhoCXk0QAvD_BwE",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-como-aman-ellas/9786124650291/p/50550058",
        year: 2019,
        themes: ["Autoayuda", "Amor"],
        linkVirrey: "https://www.elvirrey.com/libro/como-aman-ellas_70118187",
        linkSur: "https://www.libreriasur.com.pe/libro/como-aman-ellas_113122",
        linkEP: "https://www.entrepaginas.pe/libro/como-aman-ellas-31800",
        pages: 204
    },
    {
        id: 4,
        title: "Agenda astral Zéfiro 2025",
        image: "/assets/images/Book_Agenda_astral_Zéfiro_2025.png",
        sinopsis: "Esta agenda está escrita especialmente para ti, para que puedas dirigir tu vida hacia un futuro mejor, lleno de proyectos, de dicha y de salud. Incluye oraciones, tips, cábalas y un profundo estudio de cada signo zodiacal.",
        linkCrisol: "",
        linkSBS: "",
        linkIbero: "https://www.iberolibrerias.com/agenda-astral-zefiro-2025-7756444000948-169065/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-agenda-astral-zefiro-2025/7756444000948/p/62600050?srsltid=AfmBOorLwh_oORz9j6TpIrLAxTkPIJXVx6Dy6UYw0DFHbfqh2mWEm41V",
        year: 2025,
        themes: ["Agenda", "Autoayuda", "Astrología"],
        linkVirrey: "https://www.elvirrey.com/libro/agenda-astral-zefiro-2025_70146749",
        pages: 264
    },
    {
        id: 5,
        title: "Retoma tu vida",
        image: "/assets/images/Book_Retoma_tu_vida.jpg",
        sinopsis: "Con este libro, anhelo que tu corazón aprenda a dejar de sufrir y descubras las rutas del aprendizaje que nos ofrece la vida y que sepas que no somos perfectos ni tenemos que serlo para sentirnos plenos.",
        linkCrisol: "https://www.crisol.com.pe/libro-retoma-tu-vida-9786125111272?srsltid=AfmBOorSLcpogucG2yaweKYN2MLf8aFxqdMN7mhTBVMhXIYvhtAyaQ2k",
        linkSBS: "https://www.sbs.com.pe/retoma-tu-vida-9786125111272.html",
        linkIbero: "https://www.iberolibrerias.com/retoma-tu-vida-9786125111272-159660/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-retoma-tu-vida/9786125111272/p/62006657",
        year: 2024,
        themes: ["Autoayuda", "Curacion emocional"],
        linkVirrey: "https://www.elvirrey.com/libro/retoma-tu-vida_70145466",
        linkSur: "https://www.libreriasur.com.pe/libro/retoma-tu-vida_167918",
        linkEP: "https://www.entrepaginas.pe/libro/retoma-tu-vida-96845",
        pages: 188
    },
    {
        id: 6,
        title: "Tu alma responde",
        image: "/assets/images/Book_Tu_alma_responde.jpg",
        sinopsis: "Un viaje profundo hacia el autoconocimiento y la conexión con nuestra esencia. Rosa María Cifuentes nos invita a descubrir cómo nuestro interior responde a las situaciones externas, a través de herramientas de introspección, meditación y coaching espiritual.",
        linkCrisol: "https://www.crisol.com.pe/libro-tu-alma-responde-7756444000924?srsltid=AfmBOopq1PvDstDgMayUQjjxBTHOn71uk6Ck0U7xJn41L1VRdcTA7C5U",
        linkSBS: "https://www.sbs.com.pe/tu-alma-responde-7756444000924.html",
        linkIbero: "https://www.iberolibrerias.com/tu-alma-responde-7756444000924-146659/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-tu-alma-responde/7756444000924/p/56588873",
        year: 2024,
        themes: ["Autoayuda", "Curacion emocional"],
        linkVirrey: "https://www.elvirrey.com/libro/tu-alma-responde_70144117",
        linkSur: "https://www.libreriasur.com.pe/libro/tu-alma-responde_167526",
        linkEP: "http://entrepaginas.pe/libro/tu-alma-responde-96278",
        pages: 58
    },
    {
        id: 7,
        title: "Secretos de luz II",
        image: "/assets/images/Book_Secretos_de_luz_II.jpg",
        sinopsis: "Segunda parte de la serie Secretos de Luz, donde la autora nos guía para reconocer la energía que nos rodea, interpretar mensajes sutiles del universo y aplicar la luz como herramienta de transformación personal y bienestar emocional.",
        linkCrisol: "https://www.crisol.com.pe/libro-secretos-de-luz-ii-9786125111135",
        linkSBS: "https://www.sbs.com.pe/secretos-de-luz-ii-9786125111135.html",
        linkIbero: "https://www.iberolibrerias.com/secretos-de-luz-ii-9786125111135-122838/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-secretos-de-luz-ii/9786125111135/p/55754418",
        year: 2023,
        themes: ["Autoayuda"],
        linkVirrey: "https://www.elvirrey.com/libro/secretos-de-luz-ii_70141610",
        linkSur: "https://www.libreriasur.com.pe/libro/secretos-de-luz-ii_165437",
        linkEP: "https://www.entrepaginas.pe/libro/secretos-de-luz-ii-94559",
        pages: 196
    },
    {
        id: 8,
        title: "Agenda astral Zéfiro 2024",
        image: "/assets/images/Book_Agenda_astral_Zéfiro_2024.jpg",
        sinopsis: "Organiza tu vida y conecta con tu energía interior a través de esta agenda que combina astrología, numerología y consejos de bienestar para cada mes del 2024. Ideal para planificar tu año con consciencia y armonía.",
        linkCrisol: "",
        linkSBS: "",
        linkIbero: "",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-agenda-astral-zefiro-2024/7756444000665/p/55671844",
        year: 2024,
        themes: ["Agenda"],
        linkVirrey: "https://www.elvirrey.com/libro/agenda-astral-zefiro-2024_70140643",
        pages: 212
    },
    {
        id: 9,
        title: "Miénteme si puedes",
        image: "/assets/images/Book-Mienteme_si_puedes.jpg",
        sinopsis: "Con base en casos reales, este libro revela los distintos tipos de engaños y mentiras que nos afectan emocionalmente. La autora enseña cómo reconocer la manipulación y protegerse de relaciones tóxicas, promoviendo la honestidad y la conciencia emocional.",
        linkCrisol: "https://www.crisol.com.pe/libro-mienteme-si-puedes-9786125111050",
        linkSBS: "https://www.sbs.com.pe/mienteme-si-puedes-9786125111050.html",
        linkIbero: "https://www.iberolibrerias.com/mienteme-si-puedes-9786125111050-107956/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-mienteme-si-puedes/9786125111050/p/55589767",
        year: 2019,
        themes: ["Curacion Emocional", "Autoayuda"],
        linkVirrey: "https://www.elvirrey.com/libro/mienteme-si-puedes-tu-cuerpo-habla-lo-que-calla-tu-interior_70119361",
        linkSur: "https://www.libreriasur.com.pe/libro/mienteme-si-puedes_146129",
        pages: 212
    },
    {
        id: 10,
        title: "Decide ser feliz",
        image: "/assets/images/Book-Decide_ser_feliz.jpg",
        sinopsis: "Rosa María Cifuentes desmitifica las creencias sobre la felicidad y nos enseña rutas prácticas para alcanzar la paz interior. Incluye lecciones para aprender a decir 'no', superar la frustración y generar bienestar emocional, logrando un estilo de vida más pleno y consciente.",
        linkCrisol: "https://www.crisol.com.pe/libro-decide-ser-feliz-9786125111012",
        linkSBS: "https://www.sbs.com.pe/decide-ser-feliz-9786125111012.html",
        linkIbero: "https://www.iberolibrerias.com/decide-ser-feliz-9786125111012-95438/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-decide-ser-feliz/9786125111012/p/54996405",
        year: 2023,
        themes: ["Autoayuda", "Curacion Emocional"],
        linkVirrey: "https://www.elvirrey.com/libro/decide-ser-feliz_70139157",
        linkSur: "http://libreriasur.com.pe/libro/decide-ser-feliz_163512",
        linkEP: "https://www.entrepaginas.pe/libro/decide-ser-feliz-80777",
        pages: 212
    },
    {
        id: 11,
        title: "¡No más tóxicos!",
        image: "/assets/images/Book-No_mas_toxicos.jpg",
        sinopsis: "Una guía práctica para identificar relaciones tóxicas y liberarse de ellas. Rosa María Cifuentes nos enseña a establecer límites, reconocer patrones de manipulación y a crear vínculos saludables que fomenten el amor propio y la paz interior.",
        linkCrisol: "https://www.crisol.com.pe/catalogsearch/result/?q=%C2%A1No+m%C3%A1s+t%C3%B3xicos%21",
        linkSBS: "https://www.sbs.com.pe/no-mas-toxicos-9786124290909.html",
        linkIbero: "https://www.iberolibrerias.com/no-mas-toxicos-9786124290909-389970/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-no-mas-toxicos/9786124290909/p/54479914",
        year: 2023,
        themes: ["Autoayuda", "Amor"],
        linkEP: "https://www.entrepaginas.pe/libro/no-mas-toxicos-30175",
        pages: 208
    },
    {
        id: 13,
        title: "Cuentos con valores. Nueva edición",
        image: "/assets/images/Book_Cuentos_con_valores.jpg",
        sinopsis: "Una colección de cuentos destinados a enseñar valores éticos y morales a niños y jóvenes. Con historias entretenidas y educativas, promueve la empatía, la solidaridad y la reflexión sobre la vida y las relaciones humanas.",
        linkCrisol: "https://www.crisol.com.pe/libro-cuentos-con-valores-9786125060471",
        linkSBS: "https://www.sbs.com.pe/cuentos-con-valores-9786124424854.html",
        linkIbero: "https://www.iberolibrerias.com/cuentos-con-valores-9786125060471-387704/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-cuentos-con-valores/9786124424854/p/53194489",
        themes: ["Infantil"],
        year: 2021,
        pages: 80
    },
    {
        id: 14,
        title: "Agenda astral Zéfiro 2023",
        image: "/assets/images/Book-Agenda_Astral_Zefiro_2023.jpg",
        sinopsis: "Organiza tu año 2023 con la Agenda Astral Zéfiro. Incluye predicciones, rituales, consejos astrológicos y numerológicos para planificar cada mes y potenciar tu bienestar físico, emocional y espiritual.",
        linkCrisol: "",
        linkSBS: "https://www.sbs.com.pe/agenda-astral-zefiro-2023-7756444000481.html",
        linkIbero: "https://www.iberolibrerias.com/agenda-astral-zefiro-2023-7756444000481-386435/p",
        linkBuscaLibre: "",
        year: 2023,
        themes: ["Agenda", "Amor"],
        series: "",
        pages: 216
    },
    {
        id: 15,
        title: "Tarot angélico astral Zéfiro",
        image: "/assets/images/Book-Tarot_angelico_astral_Zefiro.jpg",
        sinopsis: "Cuando más lo necesitamos, el cielo nos brinda guía profunda y precisa. Ángeles, astros y números encierran las respuestas que te ayudan a encaminarte. Incluye 78 cartas a todo color y un libro con instrucciones para interpretar los mensajes del universo.",
        linkCrisol: "https://www.crisol.com.pe/libro-tarot-angelico-astral-zefiro-7756444000474",
        linkSBS: "https://www.sbs.com.pe/tarot-angelico-zefiro-7756444000474.html",
        linkIbero: "https://www.iberolibrerias.com/tarot-angelico-astral-zefiro-7756444000474-383947/p",
        linkBuscaLibre: "",
        year: 2019,
        themes: ["Autoayuda"],
        series: "",
        pages: 204
    },
    {
        id: 16,
        title: "El mal acecha",
        image: "/assets/images/Book-El_mal_acecha.jpg",
        sinopsis: "Una investigación sobre las energías negativas que nos rodean y cómo identificarlas para protegernos. Rosa María Cifuentes combina casos reales con enseñanzas espirituales para que aprendamos a mantenernos en armonía y alejados de influencias dañinas.",
        linkCrisol: "https://www.crisol.com.pe/libro-el-mal-acecha-9786124290794",
        linkSBS: "https://www.sbs.com.pe/el-mal-acecha-9786124290794.html",
        linkIbero: "https://www.iberolibrerias.com/el-mal-acecha-9786124290794-383688/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-el-mal-acecha/9786124290794/p/54225060",
        year: 2023,
        themes: ["Relaciones"],
        series: "",
        pages: 224
    },
    {
        id: 17,
        title: "Jaque mate al amor",
        image: "/assets/images/Book-Jaque_mate_al_amor.jpg",
        sinopsis: "Con base en experiencias reales, este libro revela cómo se dan los conflictos en las relaciones amorosas y cómo podemos superarlos. Incluye estrategias para evitar manipulaciones y vivir relaciones sanas y conscientes.",
        linkCrisol: "https://www.crisol.com.pe/libro-jaque-mate-al-amor-9786125027184",
        linkSBS: "https://www.sbs.com.pe/jaque-mate-al-amor-9786124290268.html",
        linkIbero: "https://www.iberolibrerias.com/jaque-mate-al-amor-9786125027184-347872/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-jaque-mate-al-amor/9786125027184/p/53978926",
        year: 2023,
        themes: ["Autoayuda", "Amor"],
        series: "",
        pages: 240
    },
    {
        id: 18,
        title: "La magia de tu casa",
        image: "/assets/images/Book-La_magia_de_tu_casa.jpg",
        sinopsis: "Descubre cómo el hogar refleja tu energía personal y cómo pequeños cambios pueden generar grandes transformaciones. Este libro enseña a armonizar los espacios, mejorar la convivencia y potenciar la energía positiva en tu casa.",
        linkCrisol: "https://www.crisol.com.pe/libro-la-magia-de-tu-casa-9786124290718",
        linkSBS: "https://www.sbs.com.pe/la-magia-de-tu-casa-9786124290718.html",
        linkIbero: "https://www.iberolibrerias.com/la-magia-de-tu-casa-9786124290718-346641/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-la-magia-de-tu-casa/9786124290718/p/53785324",
        year: 2021,
        themes: ["Relaciones", "Autoayuda", "Curacion emocional"],
        series: "",
        pages: 200
    },
    {
        id: 19,
        title: "Cábalas para recibir el Año Nuevo",
        image: "/assets/images/Book-Cabalas_para_recibir_el_ano_nuevo.jpg",
        sinopsis: "Una guía práctica con rituales, cábalas y consejos para empezar el año con buena energía y prosperidad. Incluye tradiciones, prácticas de protección y cómo atraer la fortuna, la salud y el amor en el nuevo ciclo.",
        linkCrisol: "",
        linkSBS: "https://www.sbs.com.pe/cabalas-para-recibir-el-ano-nuevo-9786124290695.html",
        linkIbero: "",
        linkBuscaLibre: "",
        year: 2021,
        themes: ["Relaciones"],
        series: "",
        pages: 200
    },
    {
        id: 20,
        title: "Agenda astral Zéfiro 2022",
        image: "/assets/images/Book-Agenda_Astral_Zefiro_2022.jpg",
        sinopsis: "Organiza tu año con esta agenda que combina astrología, predicciones mensuales, rituales y consejos para mejorar tu bienestar físico, emocional y espiritual. Ideal para planificar tu 2022 con consciencia y energía positiva.",
        linkCrisol: "",
        linkSBS: "https://www.sbs.com.pe/agenda-astral-zefiro-2022-7756444000450.html",
        linkIbero: "https://www.iberolibrerias.com/agenda-astral-zefiro-2022-7756444000450-400710/p",
        linkBuscaLibre: "",
        year: 2022,
        themes: ["Agenda", "Autoayuda"],
        series: "",
        pages: 200
    },
    {
        id: 21,
        title: "Libre del miedo",
        image: "/assets/images/Book-Libre_del_miedo.jpg",
        sinopsis: "Una guía para superar miedos, ansiedades y bloqueos que nos impiden avanzar. Rosa María Cifuentes enseña cómo transformar el miedo en oportunidades de crecimiento personal, fortaleciendo la confianza y la autoestima.",
        linkCrisol: "https://www.crisol.com.pe/libro-libre-miedo-9786124290640",
        linkSBS: "https://www.sbs.com.pe/libre-del-miedo-9786124290640.html",
        linkIbero: "https://www.iberolibrerias.com/libre-del-miedo-9786124290640-400690/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-libre-del-miedo/9786124290640/p/53449608",
        year: 2021,
        themes: ["Autoayuda", "Relaciones", "Curacion Emocional"],
        pages: 264
    },
    {
        id: 22,
        title: "Secretos de luz",
        image: "/assets/images/Book-Secretos_de_luz_2020.jpg",
        sinopsis: "Explora cómo la energía, la luz y la conciencia pueden transformar nuestra vida. La autora ofrece herramientas de autoconocimiento, sanación y desarrollo espiritual para vivir en armonía con uno mismo y con los demás.",
        linkCrisol: "https://www.crisol.com.pe/libro-secretos-luz-9786124290602",
        linkSBS: "https://www.sbs.com.pe/secretos-de-luz-9786124290602.html",
        linkIbero: "https://www.iberolibrerias.com/secretos-de-luz-9786124290602-342060/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-secretos-de-luz/9786124290602/p/53103109",
        year: 2020,
        themes: ["Autoayuda", "Relaciones"],
        pages: 200
    },
    {
        id: 23,
        title: "Agenda Astral Zéfiro 2021",
        image: "/assets/images/Book-Agenda_Astral_Zefiro_2021.jpg",
        sinopsis: "Planifica tu año 2021 con predicciones astrológicas, rituales y consejos para aprovechar cada mes. Esta agenda permite conectar con tu energía interior y tomar decisiones conscientes para un año más equilibrado y armonioso.",
        linkCrisol: "",
        linkSBS: "",
        linkIbero: "https://www.iberolibrerias.com/agenda-astral-zefiro-2021-7756444000429-340679/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-agenda-astral-zefiro-2021/7756444000429/p/52941610",
        year: 2021,
        themes: ["Autoayuda", "Agenda"],
        pages: 112
    },
    {
        id: 24,
        title: "La magia del amor",
        image: "/assets/images/Book-La_magia_del_amor.jpg",
        sinopsis: "Un libro que explora cómo atraer y mantener relaciones amorosas saludables y conscientes. Enseña a reconocer la energía de pareja, trabajar la autoestima y fortalecer el amor propio para crear relaciones plenas y armoniosas.",
        linkCrisol: "https://www.crisol.com.pe/libro-magia-amor-9786124290466",
        linkSBS: "https://www.sbs.com.pe/la-magia-del-amor-9786124290466.html",
        linkIbero: "https://www.iberolibrerias.com/la-magia-del-amor-9786124290466-339083/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-la-magia-del-amor/9786124290466/p/52358190",
        year: 2020,
        themes: ["Autoayuda", "Amor"],
        pages: 196
    }, {
        id: 25,
        title: "Como aman ellos",
        image: "/assets/images/Book-Como_aman_ellos.jpg",
        sinopsis: "Un análisis profundo de cómo los hombres aman, basado en casos reales y experiencias de vida. La autora nos guía para comprender los patrones emocionales masculinos, los miedos y cómo construir relaciones sanas y conscientes.",
        linkCrisol: "https://www.crisol.com.pe/libro-como-aman-ellos-9786124181504",
        linkSBS: "https://www.sbs.com.pe/como-aman-ellos-9786124650253.html",
        linkIbero: "https://www.iberolibrerias.com/como-aman-ellos-9786124181504-330412/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-como-aman-ellos/9786124181504/p/51435326",
        year: 2011,
        themes: ["Autoayuda", "Amor"],
        series: "",
        pages: 200
    },
    {
        id: 26,
        title: "Reo Sentimental",
        image: "/assets/images/Book-Reo_Sentimental.jpg",
        sinopsis: "Explora cómo las emociones no resueltas y los patrones de relaciones pasadas nos convierten en 'reos' de nuestros sentimientos. Un libro que enseña a liberarse de ataduras emocionales y a recuperar el control de la vida amorosa.",
        linkCrisol: "https://www.crisol.com.pe/libro-reo-sentimental-9786124181375",
        linkSBS: "https://www.sbs.com.pe/reo-sentimental-9786124290121.html",
        linkIbero: "https://www.iberolibrerias.com/reo-sentimental-9786124181375-324924/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-reo-sentimental/9786124290121/p/50549967",
        year: 2018,
        themes: ["Autoayuda", "Amor"],
        series: "",
        pages: 112
    },
    {
        id: 27,
        title: "La magia de tu nombre. Nueva edición aumentada y actualizada",
        image: "/assets/images/Book-La_magia_de_tu_nombre_Nueva_edicion.jpg",
        sinopsis: "Descubre el poder y la energía de tu nombre. Esta edición aumentada incluye análisis numerológicos, interpretaciones energéticas y herramientas para utilizar el nombre como guía para tu desarrollo personal y espiritual.",
        linkCrisol: "",
        linkSBS: "https://www.sbs.com.pe/la-magia-de-tu-nombre-nueva-edicion-aumentada-y-actualizada-9786124290411.html",
        linkIbero: "",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-la-magia-de-tu-nombre-nueva-edicion-aumentada-y-actualizada/9786124290411/p/51796523",
        year: 2019,
        themes: ["Relaciones"],
        series: "",
        pages: 250
    },
    {
        id: 28,
        title: "Presencias II",
        image: "/assets/images/Book-Presencias_II.jpg",
        sinopsis: "Segunda parte de Presencias, donde la autora narra experiencias con energías espirituales y fenómenos invisibles que influyen en nuestra vida cotidiana, ofreciendo herramientas para comprender y manejar estas experiencias.",
        linkCrisol: "https://www.crisol.com.pe/libro-presencias-2-9786124290244",
        linkSBS: "https://www.sbs.com.pe/presencias-ii-9786124290244.html",
        linkIbero: "https://www.iberolibrerias.com/presencias-ii-9786124290244-317246/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-presencias-ii/9786124290244/p/50599741",
        year: 2017,
        themes: ["Relaciones"],
        series: "",
        pages: 256
    },
    {
        id: 29,
        title: "Lesiones de amor",
        image: "/assets/images/Book-Lesiones_de_amor_25022017.jpg",
        sinopsis: "Segunda edición de Lesiones de amor, con casos adicionales y herramientas prácticas para reconocer y sanar heridas emocionales derivadas de relaciones afectivas, fortaleciendo la autoestima y el amor propio.",
        linkCrisol: "https://www.crisol.com.pe/libro-lesiones-amor-9786124290084",
        linkSBS: "https://www.sbs.com.pe/lesiones-de-amor-9786124290084.html",
        linkIbero: "https://www.iberolibrerias.com/lesiones-de-amor-9786124290084-303979/p",
        linkBuscaLibre: "https://www.buscalibre.pe/libro-lesiones-de-amor/9786124290084/p/50550331",
        year: 2017,
        themes: ["Autoayuda", "Amor"],
        series: "",
        pages: 132
    },

];

export default bookSlides;
